import React, { forwardRef, useCallback } from "react";
import Table from "../../../shared/Table";
import { COLUMN_DEFINITIONS, PAGE_SIZE_OPTIONS } from "./table.config";
import { useConfig } from "../../../hooks";
import { getProductTerminology } from "../../../constants/product-terminology";

const JobsTable = forwardRef(
  (
    {
      data,
      setSelectedJobs,
      pagination,
      pageIndex,
      pageSize,
      onPaginationChange,
      fullTextSearch,
      loading,
    },
    ref
  ) => {
    const { appType } = useConfig();
    const terms = getProductTerminology(appType);
    const handleRowSelection = useCallback(
      (value) => setSelectedJobs(value),
      [setSelectedJobs]
    );

    return (
      <Table
        ref={ref}
        search
        title={terms.jobPlural}
        columns={COLUMN_DEFINITIONS}
        data={data}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        onSelectedRowsChange={handleRowSelection}
        pagination={pagination}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
        fullTextSearch={fullTextSearch}
        loading={loading}
        manualPagination={true}
        globalSearchFilters={["loadNumber", "transactionDate"]}
      />
    );
  }
);

export default JobsTable;
